import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REVEAL_TIMEOUT_LIMITS, getRevealTimeout, setRevealTimeout } from '@/stores/preferences';

export function RevealTimeoutSetting() {
  const { t } = useTranslation();
  const [value, setValue] = useState(() => getRevealTimeout());
  const [saved, setSaved] = useState(false);
  const initial = getRevealTimeout();
  const dirty = value !== initial;

  const save = () => {
    setRevealTimeout(value);
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  return (
    <div className="space-y-3">
      <div>
        <label htmlFor="settings-page-1" className="block text-xs font-medium text-[var(--text-muted)] mb-1">
          {t('admin_ui.settings.reveal_label')}
        </label>
        <div className="flex gap-2 items-center">
          <input id="settings-page-1"
            type="number"
            min={REVEAL_TIMEOUT_LIMITS.min}
            max={REVEAL_TIMEOUT_LIMITS.max}
            className="input w-32"
            value={value}
            onChange={(e) =>
              setValue(
                Math.max(
                  REVEAL_TIMEOUT_LIMITS.min,
                  Math.min(REVEAL_TIMEOUT_LIMITS.max, Number(e.target.value) || 0),
                ),
              )
            }
          />
          <span className="text-xs text-[var(--text-muted)]">
            {t('admin_ui.settings.reveal_seconds', {
              min: REVEAL_TIMEOUT_LIMITS.min,
              max: REVEAL_TIMEOUT_LIMITS.max,
            })}
          </span>
          <button
            type="button"
            className="btn-primary text-xs ml-2"
            onClick={save}
            disabled={!dirty}
          >
            {t('common.save')}
          </button>
          {saved && <span className="text-xs text-green-600 dark:text-green-400">{t('admin_ui.settings.saved')}</span>}
        </div>
      </div>
      <p className="text-xs text-[var(--text-muted)]">
        {t('admin_ui.settings.reveal_hint')}
      </p>
    </div>
  );
}
